import { Action } from '@ngrx/store';

export class UtilsAction implements Action {

    public static getTimer: string = '[UTILS] get_timer';
    public static getTimerSuccess: string = '[UTILS] get_timer_success';
    public static getTimerError: string = '[UTILS] get_timer_error';
    public static getDateTimeSuccess = '[UTILS] get_datetime_success';

    public static enableDebugMode = '[UTILS] enable_debug_mode';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
